var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { Link as RRLink } from "react-router-dom";
import { config } from "core/utils/config";
import { Tracking } from "core/tracking";
var disableClientSideRedirect = function (url) {
    return config.slugsToServerSideRedirect.includes(url);
};
var trackLinkClick = function (trackingObject) {
    Tracking.trackProductClick(trackingObject.list, [trackingObject.product]);
};
var trackRoutingLinkClick = function (trackingObject) {
    Tracking.trackRoutingClick(trackingObject.list, [trackingObject.product]);
};
export var Link = React.forwardRef(function (_a, ref) {
    var url = _a.url, children = _a.children, className = _a.className, target = _a.target, trackingObject = _a.trackingObject, rel = _a.rel, props = __rest(_a, ["url", "children", "className", "target", "trackingObject", "rel"]);
    if (!url) {
        return (React.createElement("span", __assign({ ref: ref }, props, { className: className, onClick: function (e) {
                if (props.onClick)
                    props.onClick(e);
                if (trackingObject)
                    trackLinkClick(trackingObject);
            } }), children));
    }
    if (url.startsWith("/") && !disableClientSideRedirect(url)) {
        return (React.createElement(RRLink, __assign({ innerRef: ref, to: url, rel: rel }, props, { className: className, target: target, onClick: function (e) {
                if (props.onClick)
                    props.onClick(e);
                if (trackingObject)
                    trackLinkClick(trackingObject);
            } }), children));
    }
    return (React.createElement("a", __assign({ ref: ref, href: url, rel: rel }, props, { target: target, className: className, onClick: function (e) {
            if (props.onClick)
                props.onClick(e);
            if (trackingObject)
                trackRoutingLinkClick(trackingObject);
        } }), children));
});
